<template>
  <span></span>
</template>

<script setup>
import { computed, watch } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { toast } from '@/Mixins/toast'

const page = usePage()
const message = computed(() => page.props.message)
const errors = computed(() => page.props.errors)

watch(message, (newMessage) => {
  if (newMessage) {
    toast(newMessage)
  }
})

watch(errors, (newErrors) => {
  if (newErrors) {
    let count = 0
    outer: for (const error of Object.values(newErrors)) {
      if (typeof error === 'object') {
        for (const err of Object.values(error)) {
          toast(err, { type: 'error', hideProgressBar: false })
          count++
          if (count >= 10) break outer
        }
      } else {
        toast(error, { type: 'error', hideProgressBar: false })
        count++
        if (count >= 10) break
      }
    }
  }
}, { deep: true })

defineOptions({
  name: 'Session'
})
</script>
